import { IEltTopOpportunity } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltTopOpportunity'
import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { IColumn } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/styledComponents/styledTable/types'

import { Input } from 'core-components/library/inputs'

import styles from '../TopOpportunities.module.scss'

interface IProps {
  onChange: (field: string, index: number) => (value: string | number) => void
}

export const getTopOpportunitiesColumns = ({ onChange }: IProps): IColumn<IEltTopOpportunity>[] => {
  return [
    {
      title: getFormedEltTranslation('doc-section-top-opportunity-deal'),
      field: 'Deal',
      renderComponent: ({ value, index }) => (
        <Input
          classes={{
            root: styles.input,
          }}
          value={value || ''}
          onChange={onChange('Deal', index)}
        />
      ),
    },
    {
      title: getFormedEltTranslation('doc-section-top-opportunity-size'),
      field: 'Size',
      width: 100,
      renderComponent: ({ value, index }) => (
        <Input
          noNumberSpinner
          type={'number'}
          classes={{
            root: styles.input,
          }}
          value={value || ''}
          onChange={onChange('Size', index)}
          placeholder={'$XXM'}
        />
      ),
    },
  ]
}
